import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

export default function SignatureModal({ isOpen, onClose, onSave, fieldLabel }) {
  const sigRef = useRef(null);
  const [reason, setReason] = useState("");

  const handleSave = () => {
    if (sigRef.current && !sigRef.current.isEmpty()) {
      const dataUrl = sigRef.current.toDataURL("image/png");
      onSave(dataUrl, reason);
      handleClose();
    } else {
      alert("Please provide a signature");
    }
  };

  const handleClear = () => {
    if (sigRef.current) {
      sigRef.current.clear();
    }
  };

  const handleClose = () => {
    if (sigRef.current) {
      sigRef.current.clear();
    }
    setReason("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full shadow-xl">
        <h2 className="text-xl font-bold mb-4">Add New Signature</h2>
        <div className="text-sm text-gray-600 mb-3">
          Field: <strong>{fieldLabel}</strong>
        </div>

        <div className="border-2 border-gray-300 rounded mb-4">
          <SignatureCanvas
            ref={sigRef}
            canvasProps={{
              className: "w-full h-48 bg-white",
              style: { touchAction: "none" }
            }}
            backgroundColor="white"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Reason for new signature (optional):
          </label>
          <textarea
            className="w-full border rounded px-3 py-2 text-sm"
            rows={2}
            placeholder="e.g., Original signature unclear, correction required, etc."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            onClick={handleSave}
          >
            ✍️ Add Signature
          </button>
        </div>
      </div>
    </div>
  );
}
